import styled from "styled-components";

export const DeliveryRequestContainer = styled.div`
    width: 100%;
    height: calc(100vh - 300px); // Header ve footer için alan bırakıyoruz
    display: flex;
    flex-direction: row;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    @media screen and (max-width: 992px) {
        flex-direction: column-reverse;
        height: calc(100vh - 180px);
    }

    @media screen and (max-width: 768px) {
        height: calc(100vh - 160px);
    }
`;

export const FormSection = styled.div`
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    background-color: #ffffff;
    border-right: 1px solid #f0f0f0;

    @media screen and (max-width: 992px) {
        border-right: none;
        border-top: 1px solid #f0f0f0;
        padding: 16px;
        height: 60%;
    }

    @media screen and (max-width: 768px) {
        padding: 12px;
        height: 65%;
    }

    /* Scroll bar styling */
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
`;

export const MapSection = styled.div`
    flex: 1;
    background-color: #ffffff;
    border: 3px solid #b2fc35;
    border-radius: 8px;
    margin: 8px;

    @media screen and (max-width: 992px) {
        height: 40%;
        margin: 8px;
    }

    @media screen and (max-width: 768px) {
        height: 35%;
        margin: 6px;
    }
`;

// CustomerManualDeliveryPage için özel form container
export const CustomerManualFormContainer = styled.div`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0;
    margin: 0;

    /* Scroll bar styling */
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
`;

// CustomerManualDeliveryPage için özel map container
export const CustomerManualMapContainer = styled.div`
    border: 3px solid #b2fc35;
    border-radius: 8px;
    height: 100%;
    width: 100%;
    background-color: #ffffff;
`;

// Form içindeki elementler için kompakt stiller
export const CompactFormStyles = styled.div`
    /* Genel form stilleri */
    .ant-form {
        margin-bottom: 0 !important;
    }

    .ant-form-item {
        margin-bottom: 4px !important;
    }

    .ant-form-item:last-child {
        margin-bottom: 0px !important;
    }

    /* Input stilleri */
    .ant-input {
        padding: 5px 8px !important;
        border-radius: 4px !important;
        border: 1px solid #d9d9d9 !important;
        font-size: 12px !important;
        height: 28px !important;
    }

    .ant-input:focus,
    .ant-input-focused {
        border-color: #b2fc35 !important;
        box-shadow: 0 0 0 2px rgba(178, 252, 53, 0.2) !important;
    }

    /* Select stilleri */
    .ant-select {
        .ant-select-selector {
            padding: 3px 8px !important;
            min-height: 28px !important;
            border-radius: 4px !important;
            border: 1px solid #d9d9d9 !important;
            font-size: 12px !important;
        }

        .ant-select-focused .ant-select-selector {
            border-color: #b2fc35 !important;
            box-shadow: 0 0 0 2px rgba(178, 252, 53, 0.2) !important;
        }

        .ant-select-selection-item {
            line-height: 18px !important;
        }
    }

    /* Müşteri arama için özel padding kuralı */
    .customer-search-autocomplete .ant-select-selector {
        padding: 0 !important;
    }

    /* Müşteri arama placeholder için padding düzeltmesi */
    .customer-search-autocomplete .ant-select-selection-placeholder {
        padding: 3px 8px !important;
    }

    /* Müşteri arama seçili değer için padding düzeltmesi */
    .customer-search-autocomplete .ant-select-selection-item {
        padding: 3px 8px !important;
    }

    /* Row stilleri */
    .ant-row {
        margin-bottom: 1px !important;
    }

    /* Başlık stilleri */
    h5 {
        margin-bottom: 2px !important;
        margin-top: 4px !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        color: #333 !important;
        line-height: 1.2 !important;
    }

    /* Textarea stilleri */
    .ant-input-textarea {
        .ant-input {
            padding: 4px 8px !important;
            height: auto !important;
            min-height: 28px !important;
            resize: vertical !important;
        }
    }

    /* Tab stilleri */
    .ant-tabs {
        .ant-tabs-nav {
            margin-bottom: 8px !important;
        }

        .ant-tabs-nav-wrap {
            border-bottom: none !important;
        }

        .ant-tabs-tab {
            padding: 2px 8px !important;
            font-size: 10px !important;
            min-height: 20px !important;
            min-width: 60px !important;
            text-align: center !important;
            margin-right: 0 !important;
            border-radius: 0 !important;
            background-color: #f5f5f5 !important;
            border: 1px solid #d9d9d9 !important;
            border-right: none !important;
            transition: all 0.2s ease !important;
        }

        .ant-tabs-tab:first-child {
            border-top-left-radius: 4px !important;
            border-bottom-left-radius: 4px !important;
        }

        .ant-tabs-tab:last-child {
            border-top-right-radius: 4px !important;
            border-bottom-right-radius: 4px !important;
            border-right: 1px solid #d9d9d9 !important;
        }

        .ant-tabs-tab:hover {
            background-color: #e6f7ff !important;
            border-color: #40a9ff !important;
        }

        .ant-tabs-tab-active {
            background-color: #b2fc35 !important;
            border-color: #b2fc35 !important;
            box-shadow: 0 1px 2px rgba(178, 252, 53, 0.3) !important;
        }

        .ant-tabs-tab-btn {
            color: #666 !important;
            font-weight: 500 !important;
            width: 100% !important;
            text-align: center !important;
            line-height: 16px !important;
        }

        .ant-tabs-tab-active .ant-tabs-tab-btn {
            color: #000 !important;
            font-weight: 600 !important;
        }

        .ant-tabs-ink-bar {
            display: none !important;
        }

        .ant-tabs-nav-list {
            display: flex !important;
            width: auto !important;
        }

        .ant-tabs-tab {
            flex: none !important;
            justify-content: center !important;
        }

        .ant-tabs-tab-active + .ant-tabs-tab {
            border-left-color: #b2fc35 !important;
        }
    }

    /* CustomerSearchList border sorunu düzeltmesi */
    .ant-select-selector {
        border: 1px solid #d9d9d9 !important;
    }

    .ant-select-focused .ant-select-selector {
        border-color: #b2fc35 !important;
        box-shadow: 0 0 0 2px rgba(178, 252, 53, 0.2) !important;
    }

    /* Alıcı tel inputundaki çift border sorunu düzeltmesi */
    .ant-input[data-testid="receiverPhone"],
    .ant-input[name="receiverPhone"] {
        border: none !important;
        box-shadow: none !important;
    }

    .ant-input[data-testid="receiverPhone"]:focus,
    .ant-input[name="receiverPhone"]:focus {
        border-color: none !important;
        box-shadow: none !important;
    }

    /* Section headers için özel stil */
    .section-header {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        padding-bottom: 4px;
        border-bottom: 2px solid #f0f0f0;
    }

    .section-title {
        font-size: 14px;
        font-weight: 700;
        color: #333;
        margin-left: 8px;
    }

    /* Input row container */
    .input-row-container {
        background-color: #fafafa;
        border-radius: 6px;
        padding: 8px;
        margin-bottom: 8px;
        border: 1px solid #f0f0f0;
    }

    .input-row-title {
        font-size: 11px;
        font-weight: 600;
        color: #666;
        margin-bottom: 4px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    /* Circle marker stilleri */
    .circle-marker {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-weight: bold;
        color: white;
        margin-right: 6px;
    }

    /* Form validation stilleri */
    .ant-form-item-has-error .ant-input,
    .ant-form-item-has-error .ant-select .ant-select-selector {
        border-color: #ff4d4f !important;
    }

    .ant-form-item-explain-error {
        font-size: 10px !important;
        margin-top: 1px !important;
        color: #ff4d4f !important;
    }

    /* Button stilleri */
    .ant-btn {
        height: 28px !important;
        padding: 3px 10px !important;
        font-size: 12px !important;
        border-radius: 4px !important;
    }

    /* Upload button stilleri */
    .upload-excel-button {
        background-color: #000 !important;
        color: white !important;
        border: none !important;
        padding: 4px 10px !important;
        border-radius: 4px !important;
        font-size: 11px !important;
        font-weight: 600 !important;
        margin-bottom: 6px !important;
    }

    .upload-excel-button:hover {
        background-color: #333 !important;
    }

    /* Credit label stilleri */
    .credit-label {
        background-color: #f6ffed;
        border: 1px solid #b7eb8f;
        border-radius: 4px;
        padding: 3px 6px;
        font-size: 12px;
        font-weight: 600;
        color: #52c41a;
    }

    /* Disabled input stilleri */
    .ant-input[disabled] {
        background-color: #f5f5f5 !important;
        color: #666 !important;
        cursor: not-allowed !important;
    }

    /* Responsive optimizasyonlar */
    @media screen and (max-width: 768px) {
        .ant-form-item {
            margin-bottom: 3px !important;
        }

        h5 {
            font-size: 11px !important;
            margin-bottom: 1px !important;
        }

        .ant-input {
            padding: 3px 6px !important;
            font-size: 11px !important;
        }

        .ant-select .ant-select-selector {
            padding: 2px 6px !important;
            font-size: 11px !important;
        }

        .ant-tabs-tab {
            padding: 2px 6px !important;
            font-size: 10px !important;
        }
    }

    /* Scroll olmaması için ek optimizasyonlar */
    .ant-col {
        margin-bottom: 0 !important;
    }

    .ant-form-item-control {
        margin-bottom: 0 !important;
    }

    /* InputRow bileşeni için özel stiller */
    [data-testid="inputRow"] {
        margin-bottom: 6px !important;
    }

    [data-testid="inputRow"]:last-child {
        margin-bottom: 0 !important;
    }
`;
